import { TableComment } from "../../../../general/src/TableComment";
import { CarrierLaneRateTable } from "../CarrierLaneRateTable";
import { Checkbox, DataSource, Label, Layout, Panel, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierRate extends Layout {
    checkboxFriday: Checkbox;
    checkboxMonday: Checkbox;
    checkboxSaturday: Checkbox;
    checkboxSunday: Checkbox;
    checkboxThursday: Checkbox;
    checkboxTuesday: Checkbox;
    checkboxWednesday: Checkbox;
    labelAvailableDays: Label;
    labelLaneRate: Label;
    layoutCarrierLaneRate: CarrierLaneRateTable;
    layoutTableComment: TableComment;
    panelAvailableDays: Panel;
    panelCarrierRate: Panel;
    panelInfoOnly: Panel;
    panelRateSettings: Panel;
    panelTiming: Panel;
    sourceCarrierLaneRate: DataSource;
    sourceCarrierPayAdjustments: DataSource;
    sourceCarrierRate: DataSource;
    sourceComments: DataSource;
    tabComments: Tab;
    tabPayAdjustments: Tab;
    tableExtraPay: Table;
    tabsetPayAdjustments: Tabset;
    textboxCarrier: Textbox;
    textboxCommodity: Textbox;
    textboxCustomer: Textbox;
    textboxDeductCodeDescr: Textbox;
    textboxEffectiveDate: Textbox;
    textboxExpirationDate: Textbox;
    textboxExtraStopDedEarnCode: Textbox;
    textboxExtraStopPay: Textbox;
    textboxFuelSurchargePay: Textbox;
    textboxLastUsed: Textbox;
    textboxOrderType: Textbox;
    textboxRateNumber: Textbox;
    textboxRevenueCode: Textbox;
    textboxTimesUsed: Textbox;
    textboxTrailerType: Textbox;
}
